import {useMemo, useState} from "react";
import {Add, Delete, Edit} from "@mui/icons-material";
import {Box} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import {isDataportalNode} from "../../constants/nodes";
import ButtonSelect from "../button-select";
import ConfirmationDialog from "../confirmation-dialog";
import {clearCatalog} from "../../state/catalog/catalogActions";
import {nodeCodeSelector, nodeIdSelector, nodeSelector} from "../../state/node/nodeSelectors";
import {deleteEtlResource, showEtlWizardModal} from "../../state/package-manager/packageManagerActions";
import {userSelector} from "../../state/user/userSelectors";
import EXTRAS from "../../utils/extras";
import {canImportData} from "../../utils/permissions";

const EtlWizardResourceMenu = ({packageId, packageTitle, resourceId, structuredFrom}) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const [, setSearchParams] = useSearchParams();

  const user = useSelector(userSelector);

  const node = useSelector(nodeSelector);
  const nodeId = useSelector(nodeIdSelector);
  const nodeCode = useSelector(nodeCodeSelector);
  const nodeExtras = useMemo(() => EXTRAS.parse(node?.extras), [node]);
  const {EnableDataStore} = nodeExtras;

  const [isDeleteVisible, setDeleteVisibility] = useState(false);

  return (
    canImportData(user, nodeId) &&
    (isDataportalNode(node) || EnableDataStore) &&
    (resourceId || structuredFrom) && (
      <>
        <ButtonSelect value={t("components.etlWizardResourceMenu.label")}>
          <Box>{t("components.etlWizardResourceMenu.menu.title")}</Box>
          {resourceId && (
            <Box
              sx={{display: "flex", gap: "8px"}}
              onClick={() => dispatch(showEtlWizardModal(resourceId, false, nodeId, nodeCode, packageId, packageTitle))}
            >
              <Add /> {t("components.etlWizardResourceMenu.menu.values.add")}
            </Box>
          )}
          {structuredFrom && (
            <Box
              sx={{display: "flex", gap: "8px"}}
              onClick={() =>
                dispatch(showEtlWizardModal(structuredFrom, true, nodeId, nodeCode, packageId, packageTitle))
              }
            >
              <Edit /> {t("components.etlWizardResourceMenu.menu.values.edit")}
            </Box>
          )}
          {structuredFrom && (
            <Box sx={{display: "flex", gap: "8px"}} onClick={() => setDeleteVisibility(true)}>
              <Delete /> {t("components.etlWizardResourceMenu.menu.values.delete")}
            </Box>
          )}
        </ButtonSelect>
        <ConfirmationDialog
          title={t("components.etlWizardResourceMenu.deleteDialog.confirm.title")}
          content={t("components.etlWizardResourceMenu.deleteDialog.confirm.description")}
          open={isDeleteVisible}
          onClose={() => setDeleteVisibility(false)}
          onConfirm={() => {
            dispatch(
              deleteEtlResource(structuredFrom, nodeId, () => {
                dispatch(clearCatalog());
                const params = new URLSearchParams(location.search);
                params.delete("type");
                setSearchParams(params);
              })
            );
            setDeleteVisibility(false);
          }}
        />
      </>
    )
  );
};

export default EtlWizardResourceMenu;
